import * as React from 'react';
import { Link } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { AppState } from '@app/store';
import { openCategory } from '@app/store/catalogue/thunks';
import { setCategoryHeight } from '@app/store/sizes/actions';
import { useRef, useEffect } from 'react';
import cn from 'classnames';
import './style.scss';
import { CategoryItemProps } from './CategoryItemProps';
import { getIconById } from '@app/store/icons/selectors';
import { MetricParam, useSpatz } from '@app/hooks/useSpatz';
import { getCategoryById } from '@app/store/catalogue/selectors';

const CategoryItem: React.FC<CategoryItemProps> = ({
  levelFirst,
  category,
  isActive,
  openCategory,
  lastOpenedCategory,
  setCategoryHeight,
}) => {
  const itemRef = useRef<HTMLAnchorElement>(null);
  const icon = useSelector(getIconById(category.iconId));
  const iconActive = useSelector(getIconById(category.iconActiveId));
  const { sendSpatzStats } = useSpatz({
    Services: { catalog: { Главная: {} } },
  });
  const parentCategory = useSelector(getCategoryById(category.parentId));

  const onClickHandler = () => {
    let data: MetricParam = {};
    if (levelFirst) {
      data = {
        'клик на группу разделов': {
          click: category.title,
        },
      };
    } else {
      const parentCategoryTitle = parentCategory?.title || '';
      data = {
        'клик на раздел': {
          click: {
            [category.title]: {
              parent: parentCategoryTitle,
            },
          },
        },
      };
    }
    sendSpatzStats(data);

    openCategory(category.id, undefined);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    if (levelFirst && itemRef?.current) {
      setCategoryHeight(itemRef.current.clientHeight, category.id);
      setTimeout(() => {
        if (levelFirst && itemRef?.current) {
          setCategoryHeight(itemRef.current.clientHeight, category.id);
        }
      }, 300);
    }
  }, [category, levelFirst, setCategoryHeight]);

  const iconSrc = () => {
    const src = isActive ? iconActive?.src : icon?.src;
    if (src) {
      return { backgroundImage: `url('${src}')` };
    }
    return {};
  };

  const isOpened = lastOpenedCategory && category.id === lastOpenedCategory.id;
  return (
    <Link
      className={cn('mos-catalog_category-item', {
        'mos-catalog_category-item__active ': isActive,
      })}
      data-testid="categoryItem"
      innerRef={itemRef}
      to={category.routePath}
      role="tab"
      aria-selected={isActive ? 'true' : undefined}
      aria-label={`Категория ${category.title}`}
      onClick={onClickHandler}
    >
      {levelFirst && (
        <div
          className={`mos-catalog_category-icon mos-catalog_category-icon_${category.slug}`}
          role="presentation"
          style={iconSrc()}
        />
      )}
      {isOpened && (
        <h2 className="mos-catalog_category-item_title">{category.title}</h2>
      )}
      {!isOpened && (
        <div className="mos-catalog_category-item_title">{category.title}</div>
      )}
      {levelFirst && (
        <div className="mos-catalog_category-item_num">
          {category.servicesCount}
        </div>
      )}
    </Link>
  );
};

const mapStateToProps = (state: AppState) => ({
  lastOpenedCategory: state.catalogue.lastOpenedCategory,
  icons: state.icons,
});

const dispatchProps = {
  openCategory,
  setCategoryHeight,
};

const ConnectedCategoryItem = connect(
  mapStateToProps,
  dispatchProps
)(CategoryItem);

export default ConnectedCategoryItem;
